var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.9901 7C4.24332 7 2 9.23858 2 12C2 14.7558 4.23414 17 6.9901 17H11V15.5H6.67698C4.92575 15.5 3.5 13.9301 3.5 12C3.5 10.0703 4.9291 8.5 6.67698 8.5H11V7H6.9901ZM17.0099 17H13V15.5H17.323C19.0709 15.5 20.5 13.9297 20.5 12C20.5 10.0699 19.0742 8.5 17.323 8.5H13V7H17.0099C19.7659 7 22 9.2442 22 12C22 14.7614 19.7567 17 17.0099 17ZM10 11C9.44772 11 9 11.4477 9 12C9 12.5523 9.44772 13 10 13H14C14.5523 13 15 12.5523 15 12C15 11.4477 14.5523 11 14 11H10Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.544da4d7122842779d5761dd53b0e3eb.svg";
export { ForwardRef as ReactComponent };